import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ExtensionType, extensions } from '@pixi/extensions';
import { Rectangle } from '@pixi/math';
import { settings } from '@pixi/settings';
var ViewSystem = /*#__PURE__*/function () {
  function ViewSystem(renderer) {
    _classCallCheck(this, ViewSystem);
    this.renderer = renderer;
  }
  _createClass(ViewSystem, [{
    key: "init",
    value: function init(options) {
      this.screen = new Rectangle(0, 0, options.width, options.height);
      this.element = options.view || settings.ADAPTER.createCanvas();
      this.resolution = options.resolution || settings.RESOLUTION;
      this.autoDensity = !!options.autoDensity;
    }
  }, {
    key: "resizeView",
    value: function resizeView(desiredScreenWidth, desiredScreenHeight) {
      this.element.width = Math.round(desiredScreenWidth * this.resolution);
      this.element.height = Math.round(desiredScreenHeight * this.resolution);
      var screenWidth = this.element.width / this.resolution;
      var screenHeight = this.element.height / this.resolution;
      this.screen.width = screenWidth;
      this.screen.height = screenHeight;
      if (this.autoDensity) {
        this.element.style.width = "".concat(screenWidth, "px");
        this.element.style.height = "".concat(screenHeight, "px");
      }
      this.renderer.emit("resize", screenWidth, screenHeight);
      this.renderer.runners.resize.emit(this.screen.width, this.screen.height);
    }
  }, {
    key: "destroy",
    value: function destroy(removeView) {
      if (removeView) {
        var _this$element$parentN;
        (_this$element$parentN = this.element.parentNode) === null || _this$element$parentN === void 0 ? void 0 : _this$element$parentN.removeChild(this.element);
      }
      this.renderer = null;
      this.element = null;
      this.screen = null;
    }
  }]);
  return ViewSystem;
}();
ViewSystem.extension = {
  type: [ExtensionType.RendererSystem, ExtensionType.CanvasRendererSystem],
  name: "_view"
};
extensions.add(ViewSystem);
export { ViewSystem };